import { create } from "zustand";

/** Which terminals are touched by an active (selected or hovered) cable.
 *  `canvas.tsx` is the only writer. */

const EMPTY_TERMINALS: ReadonlySet<string> = new Set();

interface ActiveTerminalsState {
  byNode: ReadonlyMap<string, ReadonlySet<string>>;
  setByNode(byNode: ReadonlyMap<string, ReadonlySet<string>>): void;
}

export const useActiveTerminals = create<ActiveTerminalsState>((set) => ({
  byNode: new Map(),
  setByNode: (byNode) => set({ byNode }),
}));

/** A missing row returns a shared empty set, so the selector still compares by
 *  reference. */
export const activeTerminalsForNode = (
  state: ActiveTerminalsState,
  nodeId: string,
): ReadonlySet<string> => state.byNode.get(nodeId) ?? EMPTY_TERMINALS;

/** Return this from the selector, not the set — a primitive means an unchanged
 *  answer skips the re-render. */
export const activeTerminalsKey = (
  state: ActiveTerminalsState,
  nodeId: string,
): string => {
  const set = state.byNode.get(nodeId);
  if (!set || set.size === 0) return "";
  return Array.from(set).sort().join(",");
};
